import React from 'react';
import createQueue from 'unitx/async/queue';
const DEFAULT_CONCURRENCY = 1;
/* eslint-disable functional/immutable-data, functional/no-expression-statement */

export default ((config = {}) => {
  const {
    concurrency = DEFAULT_CONCURRENCY
  } = config; /// CREATE_QUEUE

  const queue = React.useMemo(() => createQueue(async (task, callback) => {
    await task();
    callback();
  }, concurrency), [concurrency]); /// ADD_QUEUE
  // const callback = React.useCallback(async (updater: Function) => {
  //   queue.push(updater)
  // }, [queue])

  return queue;
});
/* eslint-enable functional/immutable-data, functional/no-expression-statement */